import React from "react"
import { css } from "@jsUtils"
import Styles from "./closebutton.module.scss"

const CloseButton = props => {
  const { tabbing, onClose, ariaExpanded = false, ariaLabel = "Close", showText = false } = props

  return (
    <a
      href="#close"
      tabIndex={tabbing}
      type="button"
      className={Styles.closeButton}
      onClick={onClose}
      aria-expanded={ariaExpanded}
      aria-label={ariaLabel}
    >
      <div className={Styles.closeBtnWrapper}>
        {showText && <div className={Styles.eyebrow}>CLOSE</div>}
        <div className={Styles.closeWrapper}>
          <span className={css(Styles.closeItem, Styles.closeOne)} />
          <span className={css(Styles.closeItem, Styles.closeTwo)} />
        </div>
      </div>
    </a>
  )
}

export default CloseButton
